import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import type { Location } from '@/lib/types';
import { hasValue } from '@/lib/utils/has-value';

import { FieldDisplay } from './field-display';

interface SectionLocationMainProps {
  data: Partial<Location>;
}

/**
 * Main identity section for Location view pages.
 */
export const SectionLocationMain = ({ data }: SectionLocationMainProps) => {
  return (
    <Paper sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Identity
      </Typography>
      <Grid container spacing={3}>
        {hasValue(data.type) && (
          <Grid size={{ xs: 12, md: 6 }}>
            <FieldDisplay label="Type" value={data.type} />
          </Grid>
        )}
        {hasValue(data.region) && (
          <Grid size={{ xs: 12, md: 6 }}>
            <FieldDisplay label="Region" value={data.region} />
          </Grid>
        )}
        {hasValue(data.shortDescription) && (
          <Grid size={{ xs: 12 }}>
            <FieldDisplay label="Short Description" value={data.shortDescription} type="textarea" />
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};
